import { Download } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { monthLabel } from '../list/list-query';
import { downloadMonth } from './api';

/** The «sola lettura» marker of the Revisore's screens (spec §1.8). */
export function ReadOnlyMarker() {
  const { t } = useTranslation('closing');
  return (
    <span className="border-border text-muted-foreground rounded-full border px-3 py-1 text-sm">
      {t('readOnly')}
    </span>
  );
}

/** «Scarica elenco CSV» under the Revisore's list: the month the list is on, nothing else to press. */
export function AuditorDownload({ month }: { readonly month: string }) {
  const { t, i18n } = useTranslation('closing');
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState(false);
  const run = async () => {
    setBusy(true);
    setFailed(false);
    const done = await downloadMonth(month, 'list');
    setBusy(false);
    setFailed(!done);
  };
  return (
    <div className="flex flex-wrap items-center gap-3">
      <Button type="button" variant="outline" disabled={busy} onClick={() => void run()}>
        <Download />
        {t('downloads.listFor', { month: monthLabel(month, i18n.resolvedLanguage) })}
      </Button>
      {failed ? (
        <span role="alert" className="text-destructive text-sm">
          {t('downloads.failed')}
        </span>
      ) : null}
    </div>
  );
}
